'use client';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';

interface Props {
    page: string;
    title: string;
}

export default function PageViewTracker({ page, title }: Props) {
    useEffect(() => {
        if (!process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID) return;
        ReactGA.send({ hitType: 'pageview', page, title });
    }, [page, title]);
    return null;
}
